
















import { Vue, Component } from 'vue-property-decorator';

import CheckIcon from '@/components/icons/CheckBig.vue';
import { StartGuideCardActiveProgram } from '@/models/start-guide';
import DateUtils from '@/utils/DateUtils';
import { IBusinessType } from '@/models/business';
import flagKeys from '@/constants/flagKeys';
import { isOnlineProvider } from '@/utils/provider';

@Component({
  components: {
    CheckIcon
  }
})
export default class FeedbackIlustra extends Vue {
  get activePrograms() {
    return this.$store.getters[
      'startGuide/getActivePrograms'
    ] as StartGuideCardActiveProgram[];
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get isRewardBoth() {
    return this.rewardOperationType === IBusinessType.BOTH;
  }

  get isRewardOnline() {
    return this.rewardOperationType === IBusinessType.ONLINE;
  }

  get currentProvider() {
    return this.$store.getters['merchant/getCurrentProvider'];
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get rewardOperationType() {
    if (
      this.businessInfo.operationType === IBusinessType.BOTH &&
      !this.flags.includes(flagKeys.addWixMultipleIntegration)
    ) {
      if (!this.currentProvider) return IBusinessType.INSTORE;

      return isOnlineProvider(this.currentProvider.name)
        ? IBusinessType.ONLINE
        : IBusinessType.INSTORE;
    }

    return this.businessInfo.operationType;
  }

  get description() {
    if (this.isRewardBoth)
      return `Your Online program is ready, and your In-Store program will be active by ${
        this.activationDate
      }.`;

    if (this.isRewardOnline && this.fullyActive)
      return `Your Loyalty Program was launched.`;

    return `Your program should be active by ${this.activationDate}.`;
  }

  get fullyActive() {
    return this.rewardsProgramStatus === 'Active' && !this.isRewardBoth;
  }

  get rewardsProgramStatus() {
    const rewardCoinsProgram = this.activePrograms.find(
      program => program.slug === 'reward-coins'
    );

    if (!rewardCoinsProgram) return '';

    return rewardCoinsProgram.label || '';
  }

  get activationDate() {
    const numberOfDays = 3;

    const today = new Date();
    const date = new Date();
    date.setDate(today.getDate() + numberOfDays);

    return DateUtils.formattedDate({
      date,
      format: 'MMM Do',
      applyTimezone: true
    });
  }
}
